export const init = () => {
  // TRACKER 'LOST PASSWORD'
  const tracker = new AnalyticsTracker(AnalyticsConstants.trackers.customer.account.lostPassword);

  // I click on continue / ...
  const lostPasswordClickContinue = new AnalyticsClickEvent('lostPasswordClickContinue', tracker.defaultEvent());
  lostPasswordClickContinue.domContainer = '#lostPasswordForm';
  lostPasswordClickContinue.domElement = '#lostPasswordButton';
  lostPasswordClickContinue.options.label = 'Click Continue';
  tracker.addEvent(lostPasswordClickContinue);
  // ... back
  const lostPasswordClickBack = new AnalyticsClickEvent('lostPasswordClickBack', tracker.defaultEvent());
  lostPasswordClickBack.domContainer = '#lostPasswordForm';
  lostPasswordClickBack.domElement = '#cancelLostPsw';
  lostPasswordClickBack.options.label = 'Click Back';
  tracker.addEvent(lostPasswordClickBack);

  // I choose the method
  const lostPasswordChooseMethod = new AnalyticsClickEvent('lostPasswordChooseMethod', tracker.defaultEvent());
  lostPasswordChooseMethod.domContainer = '#forgottenPasswordHow';
  lostPasswordChooseMethod.domElement = '.radio label';
  lostPasswordChooseMethod.getLabel = ($element) => `Select Method ${  $element.find('input[type="radio"]').val()}`;
  tracker.addEvent(lostPasswordChooseMethod);

  // I validate the method
  const lostPasswordValidateMethod = new AnalyticsClickEvent('lostPasswordValidateMethod', tracker.defaultEvent());
  lostPasswordValidateMethod.domContainer = '#forgottenPasswordHow';
  lostPasswordValidateMethod.domElement = '#chooseButton';
  lostPasswordValidateMethod.getLabel = () =>  {
    const selectedMethod = $('[name="optionsRadios"]:checked').val();
    return `Confirm With Method ${  selectedMethod}`;
  };
  tracker.addEvent(lostPasswordValidateMethod);

  // I ask for a new code
  const lostPasswordResendCode = new AnalyticsClickEvent('lostPasswordResendCode', tracker.defaultEvent());
  lostPasswordResendCode.domContainer = '#verification-code-form';
  lostPasswordResendCode.domElement = '#sendSmsAgainResetPsw';
  lostPasswordResendCode.options.label = 'Resend Code';
  tracker.addEvent(lostPasswordResendCode);

  // I validate confirmation code / ...
  const lostPasswordValidateConfirmationCode = new AnalyticsClickEvent('lostPasswordValidateConfirmationCode', tracker.defaultEvent());
  lostPasswordValidateConfirmationCode.domContainer = '#verification-code-form';
  lostPasswordValidateConfirmationCode.domElement = '#validateCode';
  lostPasswordValidateConfirmationCode.options.label = 'Validate Code';
  tracker.addEvent(lostPasswordValidateConfirmationCode);
  // ... / back
  const lostPasswordValidateConfirmationCodeBack = new AnalyticsClickEvent('lostPasswordValidateConfirmationCodeBack', tracker.defaultEvent());
  lostPasswordValidateConfirmationCodeBack.domContainer = '#verification-code-form';
  lostPasswordValidateConfirmationCodeBack.domElement = '#cancelValidateCode';
  lostPasswordValidateConfirmationCodeBack.options.label = 'Back To Select Method';
  tracker.addEvent(lostPasswordValidateConfirmationCodeBack);

  // I validate my password reset
  const lostPasswordConfirmResetPassword = new AnalyticsClickEvent('lostPasswordConfirmResetPassword', tracker.defaultEvent());
  lostPasswordConfirmResetPassword.domContainer = '#resetPasswordForm';
  lostPasswordConfirmResetPassword.domElement = '#resetPswWithCode';
  lostPasswordConfirmResetPassword.options.label = 'Validate New Password';
  tracker.addEvent(lostPasswordConfirmResetPassword);

  // I validate my new password
  const lostPasswordValidateResetPassword = new AnalyticsClickEvent('lostPasswordValidateNewPassword', tracker.defaultEvent());
  lostPasswordValidateResetPassword.domContainer = '#resetPasswordForm';
  lostPasswordValidateResetPassword.domElement = '#validatePasswordResetButton';
  lostPasswordValidateResetPassword.options.label = 'ValidateNewPassword';
  tracker.addEvent(lostPasswordValidateResetPassword);

  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);
};



// WEBPACK FOOTER //
// ./src/analytics/trackers/customer/lost-password-tracker.js